export class InternProgressTrackerSearchModel implements IInternProgressTrackerSearchModel {
  companyId?: string | undefined;
  dateCreated?: Date | undefined;
  opportunityStudentStatus?: string | undefined;
  opportunityStudentStatusIndex?: number | undefined;
  opportunityStudentStatusLastUpdated?: Date | undefined;
  opportunityId?: string | undefined;
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
  seasonIndex?: number | undefined;
  studentId?: string | undefined;

  constructor(data?: IInternProgressTrackerSearchModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.companyId = Data["companyId"];
      this.dateCreated = Data["dateCreated"] ? new Date(Data["dateCreated"].toString()) : <any>undefined;
      this.opportunityStudentStatus = Data["opportunityStudentStatus"];
      this.opportunityStudentStatusIndex = Data["opportunityStudentStatusIndex"];
      this.opportunityStudentStatusLastUpdated = Data["opportunityStudentStatusLastUpdated"] ? new Date(Data["opportunityStudentStatusLastUpdated"].toString()) : <any>undefined;
      this.opportunityId = Data["opportunityId"];
      this.seasonNumber = Data["seasonNumber"];
      this.seasonYear = Data["seasonYear"];
      this.seasonIndex = Data["seasonIndex"];
      this.studentId = Data["studentId"];
    }
  }

  static fromJS(data: any): InternProgressTrackerSearchModel {
    data = typeof data === 'object' ? data : {};
    let result = new InternProgressTrackerSearchModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["companyId"] = this.companyId;
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data["opportunityStudentStatus"] = this.opportunityStudentStatus;
    data["opportunityStudentStatusIndex"] = this.opportunityStudentStatusIndex;
    data["opportunityStudentStatusLastUpdated"] = this.opportunityStudentStatusLastUpdated ? this.opportunityStudentStatusLastUpdated.toISOString() : <any>undefined;
    data["opportunityId"] = this.opportunityId;
    data["seasonNumber"] = this.seasonNumber;
    data["seasonYear"] = this.seasonYear;
    data["seasonIndex"] = this.seasonIndex;
    data["studentId"] = this.studentId;
    return data;
  }
}

export interface IInternProgressTrackerSearchModel {
  companyId?: string | undefined;
  dateCreated?: Date | undefined;
  opportunityStudentStatus?: string | undefined;
  opportunityStudentStatusIndex?: number | undefined;
  opportunityStudentStatusLastUpdated?: Date | undefined;
  opportunityId?: string | undefined;
  seasonNumber?: number | undefined;
  seasonYear?: number | undefined;
  seasonIndex?: number | undefined;
  studentId?: string | undefined;
}